import actionTypes from '../constants/action-types';

const show = () => ({
  type: actionTypes.SHOW,
});

export default show;
